<script lang="typescript">
import { createEventDispatcher } from 'svelte';

import { fade, slide } from 'svelte/transition';
import type { Mechanism } from '../models/Mechanism';
export let mechanism: Mechanism;
export let readOnlyMode: boolean;

const dispatch = createEventDispatcher();
function saveMechanism(mechanism) {
    dispatch('savemech', {
        prop: 'mechanism'
    });
}
$:saveMechanism(mechanism)
</script>
<div in:slide|local={{delay: 400, duration: 400}} out:slide={{duration:400}} class="editorContainer">
    <div class="mechanismDiv">
        <div class="">
            <label for="mechanismProblem">Mechanism behind the problem:</label>
            <textarea disabled={readOnlyMode}
            bind:value={mechanism.mechanismProblem}
             rows="10" id="mechanismProblem" name="mechanismProblem" class="shortBriefInput" type="text" />
        </div>
        <br/>
        <div class="">
            <label for="mechanismSolution">Mechanism behind the solution:</label>
            <textarea disabled={readOnlyMode}
            bind:value={mechanism.mechanismSolution}
             rows="10" id="mechanismSolution" name="mechanismSolution" class="shortBriefInput" type="text" />
        </div>
    </div>
</div>

<style>
.mechanismRow{
    display: flex;
    flex-direction: row;
}
.halfScreen{
    flex: 1;
    max-width: 50vw;
}
.editorContainer{
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 50vw;
    max-height: 83vh;
    overflow-y: scroll;
}
.mechanismDiv{
    padding-left: 10px;
    padding-bottom: 10px;
    flex:content;
    /* border-left: black 1px solid;
    border-right: black 1px solid;*/
    /* border-top: black 1px solid; */
    font-family: monospace;
    font-size: x-large;
}

.shortBriefInput{
    width: 95%;
    @apply border-black;
    @apply rounded;
    @apply border-2;
    background-color: rgba(255, 255, 255, 1);
}
</style>